import { create, show, useModal } from "@ebay/nice-modal-react";

import { ConfettiColored } from "components/icons/generated";
import Box from "ds/components/Box";
import Button from "ds/components/Button";
import Icon from "ds/components/Icon";
import ModalContent from "ds/components/Modal/Content";
import ModalSimple from "ds/components/ModalSimple";
import Typography from "ds/components/Typography";
import TypographyHeading from "ds/components/Typography/Heading";

import { showGenerateCertificateModal } from "../GenerateCertificateModal";

type CongratsModalProps = {
  groupId: string;
  groupName: string;
};

const CongratsModal = create(function CongratsModal({ groupId, groupName }: CongratsModalProps) {
  const modal = useModal();

  const handleNext = () => {
    modal.hide();
    showGenerateCertificateModal({ groupId });
  };

  return (
    <ModalSimple isDismissable={false}>
      <ModalContent>
        <Box direction="column" align="center" justify="center" padding="large" gap="x-large">
          <Icon src={ConfettiColored} size="xx-large" />
          <Box direction="column" align="center" justify="center" gap="medium">
            <TypographyHeading variant="p-t5" slot="title">
              Certificate earned
            </TypographyHeading>
            <Typography variant="p-body3" tag="p" align="center">
              <strong>{groupName}</strong>, certified! Grab your certificate now or later from
              Mission Control.
            </Typography>
          </Box>
          <Button variant="primary" onPress={handleNext}>
            Next
          </Button>
        </Box>
      </ModalContent>
    </ModalSimple>
  );
});

export const showCongratsModal = (props: CongratsModalProps) => show(CongratsModal, props);
